import { useEffect } from "react";
import { useRouterState } from "@tanstack/react-router";
import { isPrivatePath } from "@/lib/private-routes";
import { hasAnalyticsConsent } from "@/lib/consent";

const markKey = (pathname: string) => `rl-pv:${pathname}`;

/** Envía el page_view de una ruta pública (una vez por pestaña) si hay consentimiento. */
const sendPageView = (pathname: string) => {
  if (typeof window === "undefined") return;
  if (pathname.startsWith("/admin") || isPrivatePath(pathname)) return;
  const key = markKey(pathname);
  // No marcar la ruta como vista hasta que el evento se haya enviado con consentimiento.
  if (sessionStorage.getItem(key)) return;
  if (!hasAnalyticsConsent()) return;
  sessionStorage.setItem(key, "1");
  void import("@/lib/publicActivity").then((m) =>
    m.trackPublicEvent({ eventType: "page_view", lang: pathname.startsWith("/en") ? "en" : "es", metadata: { route: true } }),
  );
};

/** Registra una vista por cada página pública visitada (recorrido por zonas). */
export function usePublicPageViews() {
  const pathname = useRouterState({ select: (s) => s.location.pathname });
  useEffect(() => {
    sendPageView(pathname);
  }, [pathname]);

  // Al aceptar analítica en el banner, dispara el page_view de la página actual
  // con la atribución de entrada capturada al arrancar.
  useEffect(() => {
    // Llegada desde un email (utm_source=email): email_click una vez por sesión.
    void import("@/lib/publicActivity").then((m) => m.trackEmailArrival()).catch(() => {});
    const onConsent = () => {
      if (!hasAnalyticsConsent()) return;
      sendPageView(window.location.pathname);
      void import("@/lib/publicActivity").then((m) => m.trackEmailArrival()).catch(() => {});
    };
    window.addEventListener("consent_update", onConsent);
    return () => window.removeEventListener("consent_update", onConsent);
  }, []);
}
